import { render, staticRenderFns } from "./OmsAgTable.vue?vue&type=template&id=38d19c2c&scoped=true"
import script from "./OmsAgTable.vue?vue&type=script&lang=js"
export * from "./OmsAgTable.vue?vue&type=script&lang=js"
import style0 from "./OmsAgTable.vue?vue&type=style&index=0&id=38d19c2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d19c2c",
  null
  
)

export default component.exports